<template>
  <b-row
    :class="
      !(dataName && dataValue)
        ? 'mx-lg-3 mx-xl-3 py-lg-2 py-xl-2 account-list empty-account-list'
        : 'mx-lg-3 mx-xl-3 py-lg-2 py-xl-2 account-list'
    "
  >
    <b-col cols="auto" align="left">
      <span
        :class="_isDesktop ? 'account-data-label' : 'account-data-label-mobile'"
      >
        <img v-if="imageSrc" :src="imageSrc" class="mr-2" />
        {{ dataName }}
      </span>
    </b-col>
    <b-col
      align="right"
      :class="
        _isDesktop
          ? 'account-data-label-value'
          : 'account-data-label-value-mobile pl-0 ' + listClass
      "
    >
      <span>{{ dataValue }}</span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "AccountContentList",
  props: {
    imageSrc: {
      type: String,
      default: ""
    },
    dataName: {
      type: String,
      default: ""
    },
    dataValue: {
      type: String,
      default: ""
    },
    listClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.user-email {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.empty-account-list {
  border-bottom: unset;
}
</style>
